import React from "react";

const DotMatrixBackground = ({
  children,
  bgColor = "#10B981",
  isCardCover = false,
}) => {
  return (
    <div
      className={`relative ${
        !isCardCover ? "min-h-screen" : "h-20"
      }  w-full flex items-center justify-center overflow-hidden`}
      style={{ backgroundColor: `${bgColor}33` }} // Hintergrundfarbe mit 20% Opazität
    >
      <svg
        className="absolute inset-0 w-full h-full"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <pattern
            id="dotMatrix"
            width="20"
            height="20"
            patternUnits="userSpaceOnUse"
          >
            <circle cx="10" cy="10" r="1.5" fill={bgColor} />
          </pattern>
        </defs>
        <rect width="100%" height="100%" fill="url(#dotMatrix)" />
      </svg>
      <div className="relative z-10">{children}</div>
    </div>
  );
};

export default DotMatrixBackground;
